module.exports = __webpack_public_path__ + "static/bg.28268234.png";